import { AppBar, styled, Stack, Box } from '@mui/material';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundImage: 'none !important',
  backgroundColor: '#000',
  // necessary to display sidebar below app bar
  zIndex: theme.zIndex.drawer + 2,
  [theme.breakpoints.down('sm')]: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.grey[900],
  },
}));

export const Container = styled(Stack)(({ theme }) => ({
  width: '100%',
  justifyContent: 'space-between',
  paddingInline: theme.spacing(2),
  paddingLeft: theme.spacing(2.1),
}));

export const StyledLogoContainer = styled(Box)(({ theme }) => ({
  width: theme.spacing(14.125),
  marginTop: theme.spacing(1.45),
  marginLeft: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: theme.spacing(12.25),
    marginTop: theme.spacing(1.25),
    marginLeft: 0,
  },
}));
